import { downloadIconBlack, Excel } from '../../ui/assets/svgIcons/icon';
import React, { useEffect, useRef, useState } from 'react'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import getPatientAnalytics from '@custom/rtk-apis/analytics/getPatientAnalytics';
import getReportAnalytics from '@custom/rtk-apis/analytics/getReportAnalytics';
import getAppoitmentAnalytics from '@custom/rtk-apis/analytics/getAppoitmentAnalytics';
import getTurnAroundTime from '@custom/rtk-apis/analytics/getTurnAroundTime';
import getPeerReview from '@custom/rtk-apis/analytics/getPeerReview';
import getRollbackErrorTracking from '@custom/rtk-apis/analytics/getRollbackErrorTracking';
import getRadiologistPerformance from '@custom/rtk-apis/analytics/getRadiologistPerformance';
import gatCalcAvgReportTime from '@custom/rtk-apis/analytics/getCalcAvgReportTime';
import getStratBussiMatrix from '@custom/rtk-apis/analytics/getStratBussiMetrix';
import getRadiologistCaseRatio from '@custom/rtk-apis/analytics/getRadiologistCaseRatio';
import { Loader, useTheme } from '@ohif/ui';
import { Workbook } from 'exceljs';
import { servicesManager } from '../../app/src/App';
import { saveAs } from 'file-saver';

const AdminTable = ({ selectedYear }) => {
  const tableRef = useRef(null);
  const { isDarkMode } = useTheme();
  const { uiNotificationService } = servicesManager.services;
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [updateKey, setUpdateKey] = useState(0);
  const dispatch = useDispatch<AppDispatch>();
  const patientsData = useSelector((state: RootState) => state.getPatientAnalyticsResponse?.result);
  const reportsData = useSelector((state: RootState) => state.getReportAnalyticsResponse?.result);
  const appointmentsData = useSelector((state: RootState) => state.getAppoitmentAnalyticsResponse);
  const turnAroundTimeData = useSelector((state: RootState) => state.getTurnAroundTimeResponse?.result);
  const peerReviewData = useSelector((state: RootState) => state.getPeerReviewResponse);
  const rollbackErrorTrackingData = useSelector((state: RootState) => state.getRollbackErrorTrackingResponse);
  const radiologistPerformanceData = useSelector((state: RootState) => state.getRadiologistPerformanceResponse);
  const avgReportTimeData = useSelector((state: RootState) => state.getCalcAvgReportTimeResponse);
  const stratBussMetrixData = useSelector((state: RootState) => state.getStratBussiMetrixResponse);
  const radioCaseRatioData = useSelector((state: RootState) => state.getRadiologistCaseRadioResponse);

  const tabs = ['Patients', 'Reports', 'Appointments', 'Gender', 'TAT', 'Peer Review', 'Rollback Status', 'Rollback Reason', 'Reports', 'Reporting Time', 'Geographic Distribution', 'Case ratio'];

  const handleDownloadTable = async (name: string) => {
    const chartElement = tableRef.current;
    if (!chartElement) return;

    const downloadButton = chartElement.querySelectorAll('.btn__white');
    if (downloadButton) downloadButton.forEach(button => (button.style.display = 'none'));

    const canvas = await html2canvas(chartElement);
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('portrait');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.setFontSize(16);
    pdf.text(`${name} - ${selectedYear}`, 10, 15);

    // Add the table image below the title
    pdf.addImage(imgData, 'PNG', 10, 20, pdfWidth - 20, pdfHeight);

    // Show the button again after capturing
    if (downloadButton) downloadButton.forEach(button => (button.style.display = 'block'));

    pdf.save(`${name} ${selectedYear}.pdf`);
  };

  const fetchAllTableData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        dispatch(getPatientAnalytics(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getReportAnalytics(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getAppoitmentAnalytics(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getTurnAroundTime(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getPeerReview(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getRollbackErrorTracking(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getRadiologistPerformance(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(gatCalcAvgReportTime(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getStratBussiMatrix(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
        dispatch(getRadiologistCaseRatio(`?startDate=${selectedYear}-01-01&endDate=${selectedYear}-12-31`)),
      ])
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching analytics data: ", error);
    }
  }

  useEffect(() => {
    if (updateKey != 0) {
      fetchAllTableData();
    }
    setUpdateKey(updateKey + 1);
  }, [selectedYear])

  const formatReportingTime = (reportingTime) => {
    if (!reportingTime) return '--';
    const { hours = 0, minutes = 0, seconds = 0 } = reportingTime;
    return `${hours}h ${minutes}m ${seconds}s`;
  };


  const handleDownloadExcel = async () => {

    let data = [];
    let sheetName = "";
    let columns = [];

    switch (activeTab) {
      case 0: // Patients
        sheetName = "Patients";
        data = (patientsData?.monthlyRegistrations || []).map((item, index) => ({
          "S.No.": index + 1,
          "Months": item.month || '--',
          "No of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Months", "No of Cases"];
        break;

      case 1: // Reports
        sheetName = "Reports";
        data = (reportsData?.monthlyReports || []).map((item, index) => ({
          "S.No.": index + 1,
          "Months": item.month || '--',
          "No of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Months", "No of Cases"];
        break;

      case 2: // Appointments
        sheetName = "Appointments";
        data = (appointmentsData?.result?.monthlyAppointments || []).map((item, index) => ({
          "S.No.": index + 1,
          "Months": item.month || '--',
          "No of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Months", "No of Cases"];
        break;

      case 3: // Gender
        sheetName = "Gender";
        data = Object.entries(patientsData?.genderCounts || {}).map(([gender, count], index) => ({
          "S.No.": index + 1,
          "Gender": gender || '--',
          "Patients": count || '--',
        }));
        columns = ["S.No.", "Gender", "Patients"];
        break;

      case 4: // Turnaround Time
        sheetName = "Turnaround Time";
        data = (turnAroundTimeData?.aggregatedAnalytics || []).map((item, index) => ({
          "S.No.": index + 1,
          "Modality": item.modality || '--',
          "Avg TAT": item.averageTAT || '--',
          "No. of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Modality", "Avg TAT", "No. of Cases"];
        break;

      case 5: // Peer Review Cases
        sheetName = "Peer Review Cases";
        data = (peerReviewData?.result?.peerReviewedCases || []).map((item, index) => ({
          "S.No.": index + 1,
          "Users": item.name || '--',
          "Cases": item.count || '--',
        }));
        columns = ["S.No.", "Users", "Cases"];
        break;

      case 6: // Rollback Status Counts
        sheetName = "Rollback Status Counts";
        data = (rollbackErrorTrackingData?.result?.rollbackStatusCounts || []).map((item, index) => ({
          "S.No.": index + 1,
          "Status": item.name || '--',
          "No of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Status", "No of Cases"];
        break;

      case 7: // Rollback Reason Counts
        sheetName = "Rollback Reason Counts";
        data = (rollbackErrorTrackingData?.result?.rollbackReasonCounts || []).map((item, index) => ({
          "S.No.": index + 1,
          "Correction Reason": item.name || '--',
          "No of Cases": item.count || '--',
        }));
        columns = ["S.No.", "Correction Reason", "No of Cases"];
        break;

      case 8: // Number of Reports per Radiologist
        sheetName = "Number of Reports per Radiologist";
        data = (radiologistPerformanceData?.result || []).map((item, index) => ({
          "S.No.": index + 1,
          "Users": item.name || '--',
          "No of Reports": item.count || '--',
        }));
        columns = ["S.No.", "Users", "No of Reports"];
        break;

      case 9: // Average reporting time per case
        sheetName = "Average reporting time per case";
        data = (avgReportTimeData?.result?.cases || []).map((item, index) => ({
          "S.No.": index + 1,
          "Report Template Name": item.reportName || '--',
          "Reporting Time": formatReportingTime(item.reportingTime) || '--',
        }));
        columns = ["S.No.", "Report Template Name", "Reporting Time"];
        break;

      case 10: // Geographic Distribution
        sheetName = "Geographic Distribution";
        data = (stratBussMetrixData?.result?.geographicDistribution || []).map((item, index) => ({
          "S.No.": index + 1,
          "Places": item.name || '--',
          "No of Patients": item.count || '--',
        }));
        columns = ["S.No.", "Places", "No of Patients"];
        break;

      case 11: // Radiologist to Case Ratio
        sheetName = "Radiologist to Case Ratio";
        data = (radioCaseRatioData?.result?.data || []).map((item, index) => ({
          "S.No.": index + 1,
          "Users": item.radiologist || '--',
          "Case Ratio": item.ratio || '--',
          "Case Counts": item.caseCount || '--',
        }));
        columns = ["S.No.", "Users", "Case Ratio", "Case Counts"];
        break;

      default:
        return;
    }

    if (data.length === 0) {
      uiNotificationService.show({
        title: 'Unable to download Excel',
        message: "No data found to export excel",
        type: 'error',
      });
      return;
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = columns.map((key) => ({
      header: key,
      key,
      width: Math.max(20, key.length + 5), // Dynamic width
    }));

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { horizontal: 'center' };

    data.forEach((row) => worksheet.addRow(row));

    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${sheetName}_Report ${selectedYear}.xlsx`);
  };



  return (
    <div>
      <div className="tabs-container">
        <div className="tabs-header">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`tab ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="tabs-content">
          {
            activeTab == 0 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Patients</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Patients Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Months</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {patientsData?.monthlyRegistrations.map((item, index) => {
                        return <tr>
                          <td>{index + 1}</td>
                          <td>{item.month || '--'}</td>
                          <td>{item.count || '--'}</td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 1 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Reports</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Patient Reports")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Months</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {reportsData?.monthlyReports.map((item, index) => {
                        return <tr>
                          <td>{index + 1}</td>
                          <td>{item.month || '--'}</td>
                          <td>{item.count || '--'}</td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 2 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Appointments</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Appointments Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Months</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {appointmentsData?.result?.monthlyAppointments.map((item, index) => {
                        return <tr>
                          <td>{index + 1}</td>
                          <td>{item.month || '--'}</td>
                          <td>{item.count || '--'}</td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 3 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Gender</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Appointments Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Gender</th>
                      <th>Patients</th>
                    </thead>
                    <tbody>
                      {
                        Object.entries(patientsData?.genderCounts || {}).map(([gender, count], index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{gender || '--'}</td>
                            <td>{count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 4 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Turn Around Time (TAT)</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Turnaround Time Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Modality</th>
                      <th>Average TAT</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {
                        (turnAroundTimeData?.aggregatedAnalytics || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.modality || '--'}</td>
                            <td>{item.averageTAT || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 5 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Peer Review Cases</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Peer Review Cases Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Users</th>
                      <th>Cases</th>
                    </thead>
                    <tbody>
                      {
                        (peerReviewData?.result?.peerReviewedCases || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 6 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Rollback Status Counts</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Rollback Status Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Status</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {
                        (rollbackErrorTrackingData?.result?.rollbackStatusCounts || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 7 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Rollback Reason Counts</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Rollback Reason Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Correction Reason</th>
                      <th>No. of Cases</th>
                    </thead>
                    <tbody>
                      {
                        (rollbackErrorTrackingData?.result?.rollbackReasonCounts || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 8 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Number of Reports per Radiologist</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("No. of Reports Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Users</th>
                      <th>No. of Reports</th>
                    </thead>
                    <tbody>
                      {
                        (radiologistPerformanceData?.result || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 9 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Average reporting time per case</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Avg Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Report Template Name</th>
                      <th>Reporting Time</th>
                    </thead>
                    <tbody>
                      {
                        (avgReportTimeData?.result?.cases || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.reportName || '--'}</td>
                            <td>{formatReportingTime(item.reportingTime)}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 10 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Geographic Distribution of patient</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Geographic Distribution Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Places</th>
                      <th>No. of Patients</th>
                    </thead>
                    <tbody>
                      {
                        (stratBussMetrixData?.result?.geographicDistribution || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name || '--'}</td>
                            <td>{item.count || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
          {
            activeTab == 11 && <div className='tableWrap' ref={tableRef}>
              <div className='one-line'>
                <p style={{ fontSize: '20px', fontWeight: '500' }} className={isDarkMode ? 'text-white' : 'text-black'}>Radiologist to Case Ratio</p>
                <div className='flex gap-[10px]'>
                  <button className='btn btn__white' onClick={() => handleDownloadTable("Radiologist Case Ratio Tabular Report")}>
                    <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
                  </button>
                  <button className='btn btn__white' onClick={handleDownloadExcel}>
                    <img src={Excel} alt="Excel icon" />
                  </button>
                </div>
              </div>
              <div className='tableContainer'>
                <div className='tableContainer__wrap'>
                  <table className='table'>
                    <thead>
                      <th>S.No.</th>
                      <th>Users</th>
                      <th>Case Ratio</th>
                      <th>Case Counts</th>
                    </thead>
                    <tbody>
                      {
                        (radioCaseRatioData?.result?.data || []).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.radiologist || '--'}</td>
                            <td>{item.ratio || '--'}</td>
                            <td>{item.caseCount || '--'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      {<Loader isLoaderOpen={isLoading} />}
    </div>
  )
}

export default AdminTable
